import 'bootstrap/dist/css/bootstrap.min.css';
import styled from 'styled-components';
export const StyledH2 = styled.h2 `
  font-family: 'Segoe UI Semibold';
  color: #2b2828;
  font-size: 20px;
`;
//# sourceMappingURL=index.js.map